import React from "react"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"

function pageRange(page, count) {
  const pages = new Set([1, count, page - 1, page, page + 1])
  const list = [...pages].filter((p) => p >= 1 && p <= count).sort((a, b) => a - b)
  const out = []
  let prev = 0
  for (const p of list) {
    if (p - prev > 1) out.push("…")
    out.push(p)
    prev = p
  }
  return out
}

// 1-based numbered pagination
export default function Pagination({ page = 1, count = 1, onChange, className = "" }) {
  if (!count || count <= 1) return null
  const btn = "min-w-[36px] h-[36px] px-2 rounded-full inline-flex items-center justify-center text-[14px] transition-colors"
  return (
    <nav className={twMerge("flex items-center justify-center gap-1", className)} aria-label="Pagination">
      <button
        type="button"
        className={twMerge(btn, "text-text disabled:opacity-30 hover:bg-neutral")}
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        aria-label="Previous page"
      >
        <ChevronLeftIcon className="w-5 h-5" />
      </button>
      {pageRange(page, count).map((p, i) =>
        p === "…" ? (
          <span key={`e${i}`} className="px-1 text-text_secondary">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            aria-current={p === page ? "page" : undefined}
            className={twMerge(btn, p === page ? "bg-primary text-white font-bold" : "text-text hover:bg-neutral")}
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        className={twMerge(btn, "text-text disabled:opacity-30 hover:bg-neutral")}
        disabled={page >= count}
        onClick={() => onChange(page + 1)}
        aria-label="Next page"
      >
        <ChevronRightIcon className="w-5 h-5" />
      </button>
    </nav>
  )
}
